/**
 * M4.3 (Juni 2026) – Reines Mapping des ÖFFENTLICHEN Catalog-API-Response
 * (`GET /api/catalog`) auf die Landing-Preiskarten.
 *
 * KEINE Hardcodes, KEINE Preislogik: gibt ausschließlich wieder, was die API liefert.
 * Der Exposure-Guard liegt serverseitig — solange keine Katalogversion `public_visible`
 * ist, liefert die API `{published:false, products:[]}` und die Landing zeigt KEINE
 * Preise (Pre-Launch-Zustand, kein Fallback auf alte Werte).
 *
 * Reine Funktionen (testbar, ohne React/DOM).
 */

export function seatLabel(seatMin, seatMax) {
  if (seatMax == null) return `ab ${seatMin} Mitarbeiter`;
  return `${seatMin}–${seatMax} Mitarbeiter`;
}

export function eurosFromCents(cents) {
  if (cents == null) return null;
  return (cents / 100).toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Wandelt den Catalog-API-Response in `{ published, version, cards }`.
 * `published` ist nur dann true, wenn die API einen freigegebenen Katalog MIT
 * mindestens einem auf der Landing sichtbaren Produkt liefert. Andernfalls → leer.
 */
export function mapCatalogToCards(catalog) {
  const hasProducts =
    !!catalog &&
    catalog.published === true &&
    Array.isArray(catalog.products) &&
    catalog.products.length > 0;

  if (!hasProducts) {
    return { published: false, version: null, cards: [] };
  }

  const cards = catalog.products
    .filter((p) => p && p.visible_on_landing)
    .map((p) => {
      const pricing = p.pricing || {};
      const enterprise = !!p.is_custom || pricing.model === "custom";
      return {
        id: p.product_id,
        name: p.label,
        seats: seatLabel(p.seat_min, p.seat_max),
        benefit: p.description || "",
        enterprise,
        monthly_cents: enterprise ? null : pricing.monthly_net_cents ?? null,
        yearly_cents: enterprise ? null : pricing.yearly_net_cents ?? null,
      };
    });

  return { published: true, version: catalog.version || null, cards };
}
